<div>
  @if ((anyUserAllowedtoDownloadDocs$ | async) === true) {
    <app-button
      [type]="(isExecutingPackageDownloading$ | async) === true ? 'secondary' : 'primary'"
      [isDisabled]="(isExecutingPackageDownloading$ | async) === true"
      [dataTestId]="'download-documents-button'"
      (buttonClick)="onDocumentDownloadClick()"
      alt="Button to download notarization information">
      @if ((isExecutingPackageDownloading$ | async) === false) {
        <div class="button-content">
          @if ((productType$ | async) !== ProductType.RemoteSigning) {
          <img class="button-icon"
            data-testid="download-executing-closing-package-button-icon"
            src="assets/icons/file_download-icon.svg"
            alt="File download icon" />
          }
            <span>Download</span>
          </div>
        }
        @if ((isExecutingPackageDownloading$ | async) === true) {
          <div class="button-content">
            <img class="button-icon rotate"
              data-testid="downloading-executing-closing-package-button-icon"
              src="assets/icons/loading-icon.svg"
              alt="Loading icon" />
              <span>Downloading</span>
            </div>
          }
        </app-button>
      }
    </div>
